var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNumber0(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 97,
    height: 119,
    viewBox: "0 0 97 119",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_8665_233)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 39.082,
    y: 36.4766,
    width: 40,
    height: 40,
    rx: 20,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.5967 57.166C51.5967 53.4648 52.2021 50.7158 53.4131 48.9189C54.6338 47.1221 56.4941 46.2236 58.9941 46.2236C61.5039 46.2236 63.3936 47.1611 64.6631 49.0361C65.9326 50.9111 66.5674 53.6895 66.5674 57.3711C66.5674 61.043 65.9521 63.7773 64.7217 65.5742C63.501 67.3711 61.6357 68.2695 59.126 68.2695C56.6162 68.2695 54.7314 67.3418 53.4717 65.4863C52.2217 63.6309 51.5967 60.8574 51.5967 57.166ZM61.3379 51.6143C60.8691 50.4619 60.1025 49.8857 59.0381 49.8857C57.9834 49.8857 57.2266 50.4619 56.7676 51.6143C56.3184 52.7666 56.0938 54.6562 56.0938 57.2832C56.0938 59.9102 56.3184 61.79 56.7676 62.9229C57.2266 64.0557 57.9883 64.6221 59.0527 64.6221C60.1172 64.6221 60.8838 64.0459 61.3525 62.8936C61.8213 61.7314 62.0557 59.8467 62.0557 57.2393C62.0557 54.6221 61.8164 52.7471 61.3379 51.6143Z",
    fill: "url(#paint0_linear_8665_233)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_8665_233",
    x: 0.000148773,
    y: 0.000138998,
    width: 118.164,
    height: 118.164,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2.60546
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 19.5409
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.17464 0 0 0 0 0.335271 0 0 0 0 0.778754 0 0 0 0.08 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_8665_233"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_8665_233",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_8665_233",
    x1: 58.0881,
    y1: 79.5206,
    x2: 58.0881,
    y2: 43.9766,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#8533EB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#00C9B8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00F06B"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNumber0);
export default __webpack_public_path__ + "static/media/number0.a8d4a6b392e04089dbb89cefa89f07a1.svg";
export { ForwardRef as ReactComponent };